import { InjectionToken, Provider } from '@angular/core'

import { parseAppVersion } from './parse-app-version'

export const APP_VERSION = new InjectionToken<string>('APP_VERSION')

export const provideAppVersion = (source: string): Provider[] => {
  const version = parseAppVersion(source)
  return [{ provide: APP_VERSION, useValue: version }]
}
